module.exports.servant = {
  vi: {
    title: 'Người hầu trung thành của Arthur trong Avalon: luật và chiến thuật',
    description:
      'Người hầu trung thành của Arthur làm gì trong Avalon? Tìm hiểu thông tin ban đầu của vai Thiện, luật chỉ được chọn Thành công và cách giúp bảo vệ Merlin.',
    keywords: ['Người hầu', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Servo Leal de Arthur em Avalon: regras e estratégia',
    description:
      'O que faz o Servo Leal de Arthur em Avalon? Informação inicial, Sucesso obrigatório, dedução pelos votos e proteção de Merlin.',
    keywords: ['Servo', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Loyal Servant of Arthur in Avalon: Rules & Strategy',
    description:
      'What does a Loyal Servant of Arthur do in Avalon? Learn the good role’s starting information, Success-only mission rule and how to help protect Merlin.',
    keywords: ['Servant', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Сервант в Авалоне: верный слуга Артура и его правила',
    description:
      'Что делает Сервант в Авалоне? Старт без тайных знаний, обязательный успех в миссиях, поиск злых по голосам и защита Мерлина.',
    keywords: ['Сервант', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆僕人：亞瑟王忠臣的規則與策略',
    description: '阿瓦隆忠臣能做什麼？了解忠實僕人的開局資訊、任務只能出成功的限制，以及如何靠投票推理並保護梅林。',
    keywords: ['僕人', '角色', '規則', '攻略'],
  },
  'zh-CN': {
    title: '阿瓦隆仆人：亚瑟王忠臣的规则与策略',
    description: '阿瓦隆忠臣能做什么？了解忠实仆人的开局信息、任务只能出成功的限制，以及如何靠投票推理并保护梅林。',
    keywords: ['仆人', '角色', '规则', '建议'],
  },
  es: {
    title: 'Siervo Leal de Arturo en Avalon: reglas y estrategia',
    description:
      '¿Qué hace el Siervo Leal de Arturo en Avalon? Información inicial, Éxito obligatorio, deducción mediante votos y protección de Merlín.',
    keywords: ['Servidor', 'Rol', 'Reglas', 'Consejos'],
  },
};
